import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const Link = ({ id, children, title }) => (
  <OverlayTrigger
    placement="left"
    overlay={<Tooltip id={id}>{title}</Tooltip>}
  >
    <span className="nav-item">{children}</span>
  </OverlayTrigger>
);
